// Stealth Clock FE module — API client.
//
// Self-contained axios instance (same pattern as modules/employee-activity/api.js) so
// this module has no dependency on any dashboard hook or shared client. Auth is the
// logged-in user's TG JWT; the backend re-checks the org toggle and the caller's
// identity on every call — the UI gate is never the enforcement.
import axios from 'axios';
import { SERVER_URL } from '../../utils/serverConfig';

const clockApi = axios.create({
  baseURL: `${SERVER_URL}/api/v1/stealth-agent`,
  timeout: 20000,
});

clockApi.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

/** GET own shift state + today's (or ?date=) events, segments and total. */
export const getMyClock = (params = {}) =>
  clockApi.get('/clock', { params }).then((r) => r.data);

/**
 * POST a shift event. `type` is 'in' | 'out'.
 * A 409 (ALREADY_IN_STATE) is NOT a failure — it means the server's state already
 * matches, so the caller should just resync rather than show an error.
 */
export const punchClock = (type) =>
  clockApi.post('/clock', { type }).then((r) => r.data);

/** GET the org-admin read-only day timeline. params: { date?, q?, limit?, skip? } */
export const getClockTimeline = (params = {}) =>
  clockApi.get('/admin-session/clock-timeline', { params }).then((r) => r.data);

export default clockApi;
